<div class="dialog-container">
    @if (recipients) {
        <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="title-header flex-row">
            <span class="flex-1">{{ data?.timelineItem?.title | translate }}</span>
            <button (click)="close()" class="icon-button icon-close" type="button"></button>
        </div>
    }
    <div #recipientContainer class="scroll-container">
        @if ((pagedRecipients && pagedRecipients?.length) || !recipients) {
            @for (item of pagedRecipients; track item; let i = $index) {
                <app-recipient-item
                    [count]="pagedRecipients.length"
                    [item]="item"
                    [pageEvent]="{ event: pageEvent, nextPage: nextPage }"
                    [style.z-index]="pagedRecipients?.length - i"
                    [values]="{ index: i, pageChange: true }"
                    [zIndex]="pagedRecipients?.length - i"
                ></app-recipient-item>
            }
        } @else {
            <div class="no-data-container">
                <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
                <span>{{ 'default.buttons.noData' | translate }}</span>
            </div>
        }
    </div>
    <div class="container">
        <div class="paginator-holder">
            <div class="paginator-container">
                <mat-paginator
                    (page)="page($event)"
                    [hidePageSize]="true"
                    [length]="recipientLength"
                    [pageSize]="pageEvent.pageSize"
                ></mat-paginator>
            </div>
        </div>
    </div>
    @if (!recipients || loading) {
        <app-loading-indicator [backgroundColor]="'transparent'"></app-loading-indicator>
    }
</div>
